export default "__VITE_ASSET__BGieQ7Gr__"